import { BaseObjectEntity } from '@/types';
import { path } from '@/utils/formatLink';
import { generatePath } from 'react-router';

export const REFERRALS_ROOT = '/referrals';

export const PATH_REFERRALS: BaseObjectEntity = {
  root: REFERRALS_ROOT,
  list: '',
  detail: '/:referralId',
};

export function referralsPath(pathKey: string, params?: BaseObjectEntity) {
  return generatePath(path(REFERRALS_ROOT, PATH_REFERRALS[pathKey]), params);
}
